import { liteClient as algoliasearch } from 'algoliasearch/lite';
import React from 'react';
import { InstantSearch } from 'react-instantsearch';

import getConfig from '@/configs/global';

const {
  publicRuntimeConfig: {
    NEXT_PUBLIC_ALGOLIA_APPLICATION_ID,
    NEXT_PUBLIC_ALGOLIA_SEARCH_KEY,
    NEXT_PUBLIC_ALGOLIA_INDEX_NAME,
  },
} = getConfig();

const appId = NEXT_PUBLIC_ALGOLIA_APPLICATION_ID;
const searchKey = NEXT_PUBLIC_ALGOLIA_SEARCH_KEY;
const indexName = NEXT_PUBLIC_ALGOLIA_INDEX_NAME;

export const isUsingAlgolia = Boolean(appId && searchKey && indexName);

const searchClient = isUsingAlgolia ? algoliasearch(appId, searchKey) : null;

function SearchEngine({ children }) {
  if (!isUsingAlgolia) return null;

  return (
    <InstantSearch
      searchClient={searchClient}
      indexName={indexName}
      future={{ preserveSharedStateOnUnmount: true }}>
      {children}
    </InstantSearch>
  );
}

export default SearchEngine;
